import React from "react";
import PropTypes from "prop-types";
import grid from "components/grid.scss";
import styles from "components/reports/reports.scss";
import { categoryType, vendorType } from "custom-prop-types";
import { ReportsGrid } from "components/reports/reports-grid";
import { ReportsForm } from "components/reports/reports-form";

export const Reports = (props) => (
  <div className={ `${styles.container} ${grid.row}` }>
    <div className={ grid["col-md-4"] }>
      <ReportsForm
        categories={ props.categories }
        currency={ props.currency }
        onSubmitReport={ props.onSubmitReport }
        vendors={ props.vendors }
      />
    </div>
    <div className={ grid["col-md-8"] }>
      <ReportsGrid { ...props } />
    </div>
  </div>
);

Reports.propTypes = {
  categories: PropTypes.arrayOf(categoryType).isRequired,
  currency: PropTypes.string.isRequired,
  onSubmitReport: PropTypes.func.isRequired,
  vendors: PropTypes.arrayOf(vendorType).isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/reports/reports.jsx